/**
 * Local Total Cost preview while editing a margin in System Pricing. The
 * stored Proposal Cost was priced at `pricedMargin`; this moves the displayed
 * total by the draft's difference from it, so the preview stays correct even
 * when the saved margin has moved ahead of a not-yet-refreshed Proposal Cost.
 * `multiplier` turns a margin unit into dollars: 1 for Battery's flat Requested
 * Fixed Margin, the system size in watts for Solar's $/W margin.
 */
export const previewTotalCostForMargin = ({
  totalCost,
  pricedMargin,
  draftMargin,
  multiplier,
}: {
  totalCost: number
  pricedMargin: number
  draftMargin: number | null
  multiplier: number
}): number => {
  if (draftMargin == null) {
    return totalCost
  }
  return totalCost + (draftMargin - pricedMargin) * multiplier
}
